
export default {
  bind (el, binding) {
    let isDragging = false
    let offsetX, offsetY
    let firstTime = null
    let lastTime = null

    el.addEventListener('mousedown', (e) => {
      firstTime = new Date().getTime()
      isDragging = true
      offsetX = e.clientX - el.getBoundingClientRect().left
      offsetY = e.clientY - el.getBoundingClientRect().top
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    })

    function onMouseMove (e) {
      if (!isDragging) return
      let newX = e.clientX - offsetX
      let newY = e.clientY - offsetY
      // 限制位置不能超出视图范围
      newX = Math.max(0, Math.min(newX, window.innerWidth - el.offsetWidth))
      newY = Math.max(0, Math.min(newY, window.innerHeight - el.offsetHeight))

      el.style.position = 'fixed'
      // el.style.left = `${newX}px`
      el.style.top = `${newY}px`

      // 如果有绑定的回调函数，调用它
      if (binding.value && typeof binding.value === 'function') {
        binding.value({ x: newX, y: newY })
      }
    }

    function onMouseUp () {
      lastTime = new Date().getTime()
      isDragging = false
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)

      // 判断是否为拖拽操作
      if (lastTime - firstTime > 200) {
        el.setAttribute('isDraggable', true)
      } else {
        el.setAttribute('isDraggable', false)
      }
    }
  },
  unbind (el) {
    el.removeEventListener('mousedown', () => { })
  }
}
